import React, { Component } from 'react'
import { withStyles, Modal, Typography, IconButton, Grid, Button, Table, TableBody, TableCell, TableRow } from '@material-ui/core';
import Close from '@material-ui/icons/Close'
import Print from '@material-ui/icons/Print'
import Call from '@material-ui/icons/Call'
import Email from '@material-ui/icons/Email'
import ReactToPrint from "react-to-print";

const styles = theme => ({
    paper: {
        position: 'absolute',
        width: '100%',
        backgroundColor: theme.palette.background.paper,
        boxShadow: theme.shadows[5],
        padding: theme.spacing.unit * 4,
        minHeight: '100vh'
    },
    pullRight: {
        float: 'center'
    },
    image: {
        width: '100%'
    }
});


class EmployeeModal extends Component {
    render() {
        let { classes } = this.props;
        return (
            <div>
                <Modal
                    open={this.props.open}
                    onClose={this.props.handleClose}
                >
                    <div className={classes.paper}>
                        <div className={classes.pullRight}>
                            <ReactToPrint
                                trigger={() => <IconButton>
                                    <Print />
                                </IconButton>}
                                content={() => this.componentRef}
                            />
                            

                            <IconButton onClick={this.props.handleClose}>
                                <Close />
                            </IconButton>
                        </div>

                        <Details {...this.props} {...this.props.view_data} ref={el => (this.componentRef = el)}/>

                    </div>
                </Modal>
            </div>
        )
    }
}

export default withStyles(styles)(EmployeeModal);


class Details extends Component{

    render(){
        let { classes } = this.props;
        
        return (
            <div>
                <Grid container spacing={24}>
                    <Grid item xs={2} lg={2}>
                        &nbsp;
                    </Grid>
                    <Grid item>
                        <Typography variant="h6" id="modal-title">
                            {this.props.name}
                        </Typography>
                        <Typography variant="subtitle1" id="simple-modal-description">
                            {this.props.designation}, {this.props.dept_code}, {(this.props.is_HOD) ? "HOD" : ""}
                        </Typography>
                        <Typography variant="subtitle1" id="simple-modal-description">
                            <Button>
                                <Call /> {this.props.phone}
                            </Button>

                            <Button>
                                <Email /> {this.props.email.toString().toLowerCase()}
                            </Button>
                        </Typography>

                        <Table>
                            <TableBody>
                                <TableRow>
                                    <TableCell>
                                        Teaching Mode
                            </TableCell>
                                    <TableCell>
                                        {this.props.teaching_mode}
                                    </TableCell>
                                </TableRow>

                                <TableRow>
                                    <TableCell>
                                        Specialisation
                            </TableCell>
                                    <TableCell>
                                        {this.props.specialisation}
                                    </TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell>
                                        Date of birth
                            </TableCell>
                                    <TableCell>
                                        {this.props.date_of_birth}
                                    </TableCell>
                                </TableRow>

                                <TableRow>
                                    <TableCell>
                                        Date of Appointment
                            </TableCell>
                                    <TableCell>
                                        {this.props.date_of_appointment}
                                    </TableCell>
                                </TableRow>

                                <TableRow>
                                    <TableCell>
                                        Gender
                            </TableCell>
                                    <TableCell>
                                        {this.props.gender}
                                    </TableCell>
                                </TableRow>

                                <TableRow>
                                    <TableCell>
                                        Caste
                            </TableCell>
                                    <TableCell>
                                        {this.props.caste}
                                    </TableCell>
                                </TableRow>

                                <TableRow>
                                    <TableCell>
                                        Present Address
                            </TableCell>
                                    <TableCell>
                                        {this.props.present_address}
                                    </TableCell>
                                </TableRow>

                                <TableRow>
                                    <TableCell>
                                        Permanent Address
                            </TableCell>
                                    <TableCell>
                                        {this.props.permanent_address}
                                    </TableCell>
                                </TableRow>

                            </TableBody>
                        </Table>
                    </Grid>
                </Grid>

            </div>
        )
    }
    
}


// WEBPACK FOOTER //
// ./src/Components/Employee/Add/EmployeeModal.js